import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './Newborn.css';
import { Link } from 'react-router-dom';

function Newborn() {
  const [selectedImage, setSelectedImage] = useState(null);
  const images = [
    { src: "/images/newborn/newborn.jpg", alt: "Newborn 1" },
    { src: "/images/newborn/newborn-2.jpg", alt: "Newborn 2" },
    { src: "/images/newborn/newborn-3.jpg"  , alt: "Newborn 3" },
    { src: "/images/newborn/newborn-4.jpg", alt: "Newborn 4" },
    { src: "/images/newborn/newborn-5.jpg", alt: "Newborn 5" },
    { src: "/images/newborn/newborn-6.jpg", alt: "Newborn 6" }
  ];

  const handleImageClick = (index) => {
    setSelectedImage(index);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handlePrevImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNextImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    if (selectedImage === null) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleCloseModal();
      if (e.key === 'ArrowRight') handleNextImage();
      if (e.key === 'ArrowLeft') handlePrevImage();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, images]);

  return (
    <div className="newborn-section">
      <Helmet>
        <title>Newborn Photography in Bristol | Baby Portraits Studio</title>
        <meta name="description" content="Natural, studio-based newborn photography in Bristol. Serving families in Wales and the South West UK." />
        <meta name="keywords" content="newborn photography, baby portraits, Bristol newborn photographer, baby photography studio, South West UK photography" />
        <meta property="og:title" content="Newborn Photography in Bristol | Baby Portraits Studio" />
        <meta property="og:description" content="Natural, studio-based newborn photography in Bristol. Serving families in Wales and the South West UK." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/services/newborn" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/services/newborn" />
      </Helmet>
      <div className="header-img-container">
        <img className="header-img" src="/images/newborn/newborn.jpg" alt="Newborn header" />
        <div className="header-img-overlay">
          <h1 className="header-title-mobile">Newborn</h1>
          <p>Capture the precious moments of your newborn with our specialized photography services.</p>
        </div>
      </div>
      <h1 style={{display:'none'}}>Newborn</h1>
      <p style={{display:'none'}}>Beautiful newborn photography to capture your little one's first moments.</p>
      <div className="gallery-grid-newborn">
        {images.map((image, index) => (
          <img key={index} className="gallery-img" src={image.src} alt={image.alt} onClick={() => handleImageClick(index)} />
        ))}
      </div>
      {selectedImage !== null && (
        <div className="album-modal-overlay" onClick={handleCloseModal}>
          <div className="album-modal" onClick={(e) => e.stopPropagation()}>
            <button className="album-close-btn" onClick={handleCloseModal}>&times;</button>
            <button className="album-arrow album-arrow-left" onClick={handlePrevImage}>&#8592;</button>
            <img className="album-image" src={images[selectedImage].src} alt={images[selectedImage].alt} />
            <button className="album-arrow album-arrow-right" onClick={handleNextImage}>&#8594;</button>
            <div className="album-indicators">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  className={idx === selectedImage ? 'album-dot active' : 'album-dot'}
                  onClick={() => setSelectedImage(idx)}
                  aria-label={`Go to image ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      )}
      <div className="gallery-cta">
        <h1>Natural Newborn Photography in Bristol, Wales & the South West</h1>
       <p>Those first days with your baby are fleeting — let's capture them beautifully. Our studio newborn photography sessions are calm, gentle, and baby-led, creating timeless portraits that reflect the love and tenderness of this special time.

Located in Newport and welcoming families from across South West England and Wales, our cozy studio is designed for comfort and safety — providing a warm, peaceful environment for both baby and parents. With soft natural lighting, minimal props, and a relaxed approach, we focus on emotion, connection, and the tiny details you'll want to remember forever.

Whether it's your first baby or you're growing your family, we're here to make the experience stress-free and memorable — with stunning images you'll treasure for a lifetime.

Preserve the magic of your baby's first days — safely, naturally, beautifully.</p>

        <Link to="/contact" className="gallery-cta-btn">Book Now</Link>
      </div>
    </div>
  );
}

export default Newborn; 